import Card from "../../Card/component";
import { CARD_TYPES } from "../../Card/constants";
import { DISPLAY_TYPES } from "../../ContentList/constants";
import Ad from "../../Ad/component";
import { compose } from "../../../utils/render/library";
import { normalizeClass } from "../../../utils/path/library";
import { NATIVE_AD_TYPE } from "../../Ad/constants";
import featureAttr from "../../../utils/featureAttr";
import { DEFAULT_MAP_KEY } from "../constants";

/**
 * @class DisplayPolicy
 */
class DisplayPolicy {
    // PUBLIC

    /**
     * @param {Array} list The list of content items to format for display
     * @param {object} sections The sections that *all* items are contained within
     * @param {Function} cardClickHandler A method to pass down to a Card's onClick event
     * @returns {Array} A list of React.Element instances to render
     */
    format(list, sections, cardClickHandler, displayType, variant) {
        const feature = list?.feature;
        this.buildCardTypesMap(list.length);

        const itemsAndCardTypes = list.map((item, index) =>
            this.getItemAndCardTypeAtIndex(item, index)
        );

        const items = itemsAndCardTypes.map(
            ({ cardType, contentItem }, index) => {
                let cardComponent;
                if (contentItem.type === NATIVE_AD_TYPE) {
                    cardComponent = (
                        <Ad
                            key={contentItem.key}
                            type={contentItem.type}
                            targeting={contentItem.targeting}
                            cardType={cardType}
                            callback={contentItem.callback}
                        />
                    );
                } else {
                    let trackingClass;
                    const cardKey = `key-${contentItem.contentId}-${index}`;
                    let cardFeature = feature;
                    if (
                        contentItem.id &&
                        contentItem.id.toString().startsWith("keymatch_")
                    ) {
                        cardFeature = { ...cardFeature, instance: "nlp-match" };
                    } else {
                        trackingClass = sections.trackingSection
                            ? normalizeClass(
                                  `sclt`,
                                  sections.trackingSection,
                                  `card${index}`
                              )
                            : `sclt-card${index}`;
                    }

                    const cardProps = {
                        type: cardType,
                        baseSection: sections.baseSection,
                        subSection: sections.subSection,
                        className: trackingClass,
                        cardClickHandler: cardClickHandler,
                        cardIndex: index,
                        variant,
                        feature:
                            feature &&
                            featureAttr({
                                position: index + 1,
                                ...cardFeature,
                            }),
                        displayType,
                    };

                    if (displayType !== DISPLAY_TYPES.TYPE_LIST) {
                        cardProps.key = cardKey;
                    }
                    cardComponent = <Card {...cardProps} {...contentItem} />;
                    // When hitting Load More, insert an Ad between the cards
                    if (typeof contentItem.insertAd !== "undefined") {
                        const children = compose(
                            cardComponent,
                            <div className="adCardWrapper">
                                <Ad
                                    type="load-more"
                                    lazy
                                    targeting={{ plc: "more" }}
                                />
                            </div>
                        );
                        return children;
                    }

                    if (displayType === DISPLAY_TYPES.TYPE_LIST) {
                        return (
                            <li className="contentListItem" key={cardKey}>
                                {cardComponent}
                            </li>
                        );
                    }
                }

                return cardComponent;
            }
        );
        return items;
    }

    buildCardTypesMap() {
        this.cardTypesMap = new Map();
        this.cardTypesMap.set(DEFAULT_MAP_KEY, CARD_TYPES.TYPE_DEFAULT);
    }

    getItemAndCardTypeAtIndex(item, index) {
        const cardType =
            this.cardTypesMap.get(index) ||
            this.cardTypesMap.get(DEFAULT_MAP_KEY);
        return { contentItem: item, cardType };
    }
}

export default DisplayPolicy;
